export default __webpack_public_path__ + "static/novedades_desktop-c97f8fef73cb112fef4df3c4d7683c68.jpg";